import { Sentry } from './sentry'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Capacitor } from '@capacitor/core'
import './index.css'
import App from './App.tsx'

// Signal to Capawesome that the current bundle loaded successfully (prevents rollback)
if (Capacitor.isNativePlatform()) {
  import('@capawesome/capacitor-live-update').then(({ LiveUpdate }) => {
    LiveUpdate.ready();
  });
}

function SentryFallback() {
  return (
    <div style={{ padding: 40, textAlign: 'center', fontFamily: 'system-ui' }}>
      <h1>Something went wrong</h1>
      <p style={{ color: '#666', margin: '12px 0 24px' }}>
        An unexpected error occurred. Please try again.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '10px 24px',
          borderRadius: 8,
          border: 'none',
          background: '#111',
          color: '#fff',
          fontSize: 16,
          cursor: 'pointer',
        }}
      >
        Reload
      </button>
    </div>
  );
}

function getRoot() {
  const container = document.getElementById('root')!;

  // Remove React 19's internal root markers (properties like __reactContainer$xxx)
  // that can survive soft reloads in WKWebView
  for (const key of Object.getOwnPropertyNames(container)) {
    if (key.startsWith('__react')) {
      delete (container as any)[key];
    }
  }

  try {
    return createRoot(container);
  } catch {
    // If createRoot still fails, replace the node entirely
    const fresh = document.createElement('div');
    fresh.id = 'root';
    container.parentNode!.replaceChild(fresh, container);
    return createRoot(fresh);
  }
}

getRoot().render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={SentryFallback}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)

// Global fallback for unhandled errors that escape React's ErrorBoundary
window.addEventListener('error', (e) => {
  console.error('[Global] Unhandled error:', e.error ?? e.message);
});
window.addEventListener('unhandledrejection', (e) => {
  console.warn('[Global] Unhandled promise rejection:', e.reason);
  e.preventDefault(); // Prevent crash
});
